// extracted by mini-css-extract-plugin
export var footer = "_ml-5";
export var fulfillmentInput = "_ml-0";
export var shipDateInput = "_ml-1";
export var shipmentModal = "_ml-2";
export var shipmentModalContent = "_ml-3";
export var tableContainer = "_ml-4";